import { TagCategory } from '@exam-center/graphql';
import { Flex, Text } from '@shared/components';
import { useMemo } from 'react';

import { useExamEventScoreReport } from '../../providers/exam-event-score-report-provider/use-exam-event-score-report';

function getLegendTitle(tagCategory: TagCategory | null) {
  if (tagCategory === TagCategory.Part) return 'คำอธิบายคะแนนรายหมวด:';
  if (tagCategory === TagCategory.Subject) return 'คำอธิบายคะแนนรายวิชา:';

  return 'คำอธิบายคะแนน:';
}

export default function ExamEventScoreReportScoreLegendSection() {
  const { orderedQConfigStructures, selectedTagCategory, hasFilters } = useExamEventScoreReport();

  const legendItems = useMemo(() => {
    return [...orderedQConfigStructures]
      .sort((a, b) => a.calculatedOrder - b.calculatedOrder)
      .map((structure, index) => ({
        displayOrder: index + 1,
        order: structure.calculatedOrder,
        name: structure.qConfigStructure.name ?? '-',
      }));
  }, [orderedQConfigStructures]);

  const shouldUseTwoColumns = legendItems.length > 6;
  const midpoint = Math.ceil(legendItems.length / 2);

  const leftColumnItems = shouldUseTwoColumns ? legendItems.slice(0, midpoint) : legendItems;
  const rightColumnItems = shouldUseTwoColumns ? legendItems.slice(midpoint) : [];

  if (!hasFilters || legendItems.length === 0) {
    return null;
  }

  return (
    <Flex
      sx={(theme) => ({
        p: theme.spacing(4),
        border: '1px solid',
        borderColor: theme.palette.grey[300],
        borderRadius: theme.shape.rounded(2),
        flexDirection: 'column',
        gap: theme.spacing(1),
      })}
    >
      <Text variant='body2Semibold'>{getLegendTitle(selectedTagCategory)}</Text>

      <Flex
        sx={(theme) => ({
          gap: theme.spacing(8),
          flexDirection: shouldUseTwoColumns ? 'row' : 'column',
        })}
      >
        <Flex
          sx={{
            flex: 1,
            flexDirection: 'column',
          }}
        >
          {leftColumnItems.map((item) => (
            <Text key={`score-legend-left-${item.order}`} variant='body2'>
              {item.displayOrder} = {item.name}
            </Text>
          ))}
        </Flex>

        {shouldUseTwoColumns ? (
          <Flex
            sx={{
              flex: 1,
              flexDirection: 'column',
            }}
          >
            {rightColumnItems.map((item) => (
              <Text key={`score-legend-right-${item.order}`} variant='body2'>
                {item.displayOrder} = {item.name}
              </Text>
            ))}
          </Flex>
        ) : null}
      </Flex>
    </Flex>
  );
}
